import React from 'react'

const CopyIcon = (props: any = {}) => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5 9.16602C5 6.80899 5 5.63048 5.73223 4.89825C6.46447 4.16602 7.64298 4.16602 10 4.16602H12.5C14.857 4.16602 16.0355 4.16602 16.7678 4.89825C17.5 5.63048 17.5 6.80899 17.5 9.16602V13.3327C17.5 15.6897 17.5 16.8682 16.7678 17.6005C16.0355 18.3327 14.857 18.3327 12.5 18.3327H10C7.64298 18.3327 6.46447 18.3327 5.73223 17.6005C5 16.8682 5 15.6897 5 13.3327V9.16602Z" stroke={props?.color ?? "var(--primary)"} strokeWidth="1.25" />
            <path d="M5 15.8327C3.61929 15.8327 2.5 14.7134 2.5 13.3327V8.33268C2.5 5.18999 2.5 3.61864 3.47631 2.64233C4.45262 1.66602 6.02397 1.66602 9.16667 1.66602H12.5C13.8807 1.66602 15 2.7853 15 4.16602" stroke={props?.color ?? "var(--primary)"} strokeWidth="1.25" />
        </svg>
    )
}

export default CopyIcon